import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M101.5 75.892a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#ACB8C3"
      d="M52.114 16.322a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M29.959 84.892a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M55.67 97.203a1.5 1.5 0 0 1 0 2.121l-9.992 9.993a1.5 1.5 0 1 1-2.122-2.121l9.993-9.993a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M43.556 97.203a1.5 1.5 0 0 1 2.122 0l9.993 9.993a1.5 1.5 0 1 1-2.122 2.121l-9.993-9.993a1.5 1.5 0 0 1 0-2.121M76.839 5.256a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V6.756a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M68.272 13.822a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 1 1 0 3H69.772a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      d="m26.516 56.966 3.628-23.704a4.96 4.96 0 0 1 4.03-4.135l22.724-4.076a4.96 4.96 0 0 1 4.383 1.373l32.399 32.34a4.964 4.964 0 0 1 .048 6.978L67.483 92.678a4.963 4.963 0 0 1-7.009.1L27.968 61.282a4.96 4.96 0 0 1-1.452-4.316"
    />
    <path
      fill="#F1F4FA"
      d="M41.554 45.91a4.624 4.624 0 1 0 0-9.249 4.624 4.624 0 0 0 0 9.248"
    />
    <path
      fill="#7B8493"
      fillRule="evenodd"
      d="M57.824 39.715a2.25 2.25 0 0 1 3.182-.04L81.1 59.264a2.25 2.25 0 1 1-3.142 3.221l-20.094-19.59a2.25 2.25 0 0 1-.04-3.181M49.14 49.51a2.25 2.25 0 0 1 3.182-.041l20.094 19.589a2.25 2.25 0 0 1-3.142 3.222L49.18 52.691a2.25 2.25 0 0 1-.04-3.181M41.018 58.006a2.25 2.25 0 0 1 3.182-.04l12.996 12.67a2.25 2.25 0 1 1-3.142 3.222l-12.996-12.67a2.25 2.25 0 0 1-.04-3.183"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconCostCodesGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconCostCodesGreyscale);
export default Memo;
